<template>
    <div id="leftPanel" style="margin-top: 1px;">
      <v-card flat style="height: 100%; padding: 0; background: inherit;">
        <div style="text-align-last: center;"
             class="leftPanel__header d-flex justify-center align-items-center align-center border-bottom pt-2">
          <div class="svg-container">
            <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M3.19893 10.3882C6.83148 4.32002 13.4733 0.25 21.0693 0.25H21.8193L21.8193 20.2918L39.6099 30.5627L39.2498 31.2081C35.6944 37.5803 28.8858 41.8887 21.0693 41.8887C13.2522 41.8887 6.45003 37.5741 2.88933 31.2089M20.3193 20.2918L20.3193 1.76429C13.5867 2.02137 7.73878 5.72478 4.48595 11.1586C2.75019 14.0609 1.75 17.4483 1.75 21.0693C1.75 24.215 2.50417 27.181 3.84011 29.8057L20.3193 20.2918ZM4.57185 31.1152L21.0693 21.5908L37.5675 31.1156C34.1777 36.6792 28.0567 40.3887 21.0693 40.3887C14.0829 40.3887 7.9669 36.6747 4.57185 31.1152ZM2.88933 31.2089C1.20928 28.2063 0.25 24.75 0.25 21.0693C0.25 17.168 1.32861 13.5153 3.19893 10.3882" fill="#CCCCCC"/>
              <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M20.3193 0.25H21.0693C28.6654 0.25 35.3072 4.32002 38.9397 10.3882L39.0462 10.5661V10.5737C40.8512 13.6555 41.8887 17.2429 41.8887 21.0693C41.8887 24.7509 40.9233 28.2066 39.2499 31.2079L38.8792 31.8729L20.3193 21.1578V0.25ZM21.8193 1.76429V3.34103L23.2847 1.87568C22.8014 1.82049 22.3128 1.78314 21.8193 1.76429ZM25.1086 2.17307L21.8193 5.46235V8.18753L27.2475 2.75935C26.5515 2.52449 25.8377 2.32821 25.1086 2.17307ZM28.7782 3.34996L21.8193 10.3088V13.0283L30.591 4.2566C30.0052 3.92396 29.4002 3.62106 28.7782 3.34996ZM31.899 5.06993L21.8193 15.1496V17.8748L33.4523 6.24186C32.9551 5.82605 32.4368 5.43479 31.899 5.06993ZM34.5662 7.24924L21.8193 19.9961V20.2918L23.7965 21.4332L36.1867 9.04299C35.684 8.4117 35.1427 7.81258 34.5662 7.24924ZM37.0848 10.2662L25.1414 22.2097L27.3023 23.4572L38.342 12.4175C38.1274 11.9906 37.8974 11.5728 37.6529 11.1646L37.5462 10.9866V10.9828C37.3976 10.7404 37.2437 10.5015 37.0848 10.2662ZM39.0019 13.8789L28.6472 24.2337L30.8154 25.4854L39.8349 16.4659C39.6171 15.5779 39.3379 14.714 39.0019 13.8789ZM40.1822 18.24L32.1603 26.2619L34.3179 27.5075L40.3876 21.2765C40.3883 21.2075 40.3887 21.1385 40.3887 21.0693C40.3887 20.1081 40.3182 19.1634 40.1822 18.24ZM40.2238 23.5943L35.6581 28.2813L38.2977 29.8051C39.2675 27.8944 39.9332 25.8033 40.2238 23.5943Z" fill="currentColor"/>
            </svg>
          </div>
         <h5 class="mt-1">PX Übersicht</h5>
        </div>
        <div>
          <div class="px-4">
            <h6>
              Allgemeine Daten zum Prozessmodell
            </h6>
            <v-simple-table>
              <template v-slot:default>
                <tbody>
                <tr
                    v-for="item in contextInfo"
                    :key="item.name"
                >
                  <td>{{ item.name }}</td>
                  <td>{{ item.value }}</td>
                </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
          <v-divider />
          <div class="px-4">
            <h6 class="mb-4">
              Umfrage zur Auswertung auswählen
            </h6>
            <div class="px-2">
              <v-select
              :disabled="this.surveys.length < 1"
              v-model="selectedSurvey"
              :items="surveys"
              item-text="title"
              label="Ausgewählte Umfrage"
              return-object
              >
              <template slot="item" slot-scope="data">
                <!-- HTML that describe how select should render items when the select is open -->
                {{ data.item.createdDate | moment("DD.MM.YYYY") }} - {{ data.item.title }}
              </template>
            </v-select>
            </div>
          </div>
          <div class="px-4">
            <h6 class="mb-4">Daten zur Umfrage</h6>
            <v-simple-table>
              <template v-slot:default>
                <tbody>
                <tr
                    v-for="item in selectedSurveyDisplayData"
                    :key="item.name"
                >
                  <td>{{ item.name }}</td>
                  <td>{{ item.value }}</td>
                </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
          <div class="d-flex justify-center mt-8 pb-6">
            <v-btn v-if="(!showEval && selectedSurvey != null)"
                   :disabled="selectedSurvey.info.answeredCount == 0"
                   elevation="0"
                   color="secondary"
                   @click="evaluateSurvey()">
              <v-icon>mdi-chart-timeline-variant</v-icon>
              Auswertung anzeigen
            </v-btn>
            <v-btn v-if="showEval"
                   :disabled="(selectedSurvey.info.answeredCount == 0)"
                   elevation="0"
                   color="secondary"
                   @click="cancel()">
              <v-icon>mdi-chart-timeline-variant</v-icon>
              Auswertung ausblenden
            </v-btn>
          </div>
        </div>
      </v-card>
    </div>
</template>


<script>
  import processListService from "@/pages/ProcessList/processlist-service.js"
  import {decodeSurveyState} from "@/components/util.js"
  export default { 
  props: [ 'contextInformations', 'surveyEvaluations', 'uuid', 'surveyId'],
  data() {
     return {
       selectedSurvey: null,
       selectedSurveyDisplayData: null,
       selectedElementEvaluations: [],
       showEval: null,
       surveys: [],
       loading: false,
       surveyReloaded: false,
     }
  },
  computed: {
    evaluations(){
        return null;
    },
    contextInfo(){
        return [
            {name: "Anzahl Umfragen", value: this.contextInformations.surveyCount},
            {name: "Anzahl Antworten", value: this.contextInformations.answerCount},
            {name: "Anzahl Auswertungspunkte", value: this.contextInformations.timestampCount}
        ]
    }
  },
  watch:{
    selectedSurvey(){
        this.showEval = false;
        this.$emit("toggleEvaluation", {
            evalData: this.selectedElementEvaluations, 
            showEvalVal: false,
            survey: this.selectedSurvey
        });
        this.selectedSurveyDisplayData = [
            {name: "Anzahl Versendet", value: this.selectedSurvey.info.sendToCount},
            {name: "Anzahl Antworten", value: this.selectedSurvey.info.answeredCount},
            {name: "Status", value: this.decodeSurveyState(this.selectedSurvey.info.state)}
        ]
        this.selectedElementEvaluations = this.surveyEvaluations.find(elem => elem.surveyId == this.selectedSurvey.id);
        if(this.selectedElementEvaluations == null) {
            this.selectedElementEvaluations = [];
        }else{
            this.selectedElementEvaluations = this.selectedElementEvaluations.elementEvaluations;
        }
        this.surveyReloaded = true;
    }
  },
  async mounted(){
    processListService.retrieveSurveysForProcess(this.uuid).then(res => {
      this.surveys = res.data;
      if(this.surveyId != null){
        this.showEval = false;
        this.selectedSurvey = this.surveys.find(elem => elem.id == this.surveyId);
        this.loadEval();
      }
    });
  },
  methods: {
    decodeSurveyState:decodeSurveyState,
    async loadEval(){
      await new Promise((resolve) => {
        if(this.surveyReloaded){
          resolve();
        }else{
          const unwatch = this.$watch('surveyReloaded', (newVal) => {
           if (newVal) {
             unwatch();
             resolve();
           }
         });
        }
      })
      this.selectedElementEvaluations = this.surveyEvaluations.find(elem => elem.surveyId == this.selectedSurvey.id);
      if(this.selectedElementEvaluations == null) {
          this.selectedElementEvaluations = [];
      }else{
          this.selectedElementEvaluations = this.selectedElementEvaluations.elementEvaluations;
      }
      this.evaluateSurvey();
    },
    timeConverter(timestamp) {
      let dt = new Date(timestamp);
      let months = ['Jan','Feb','Mär','Apr','Mai','Jun','Jul','Aug','Sep','Oct','Nov','Dez'];
      let year = dt.getFullYear();
      let month = months[dt.getMonth()];
      let date = dt.getDate();
      let time = month + ' ' + date + '. ' + year;
      return time
    },
    evaluateSurvey(){
        this.showEval = true;
        this.$emit("showSidePanel", false);
        this.$emit("toggleEvaluation", {
            evalData: this.selectedElementEvaluations, 
            showEvalVal: true,
            survey: this.selectedSurvey,
        });
    },
    cancel(){
        this.showEval = false;
        this.$emit("toggleEvaluation", {
            evalData: this.selectedElementEvaluations, 
            showEvalVal: false,
            survey: this.selectedSurvey
        });
    }
  },
  
}
</script>



<style scoped>
#leftPanel{
    position: absolute;
    top: 10%;
    bottom: 15%;
    width: 300px;
    height: 75%;
    left: 25px;
    border: 1px solid var(--gray-color_4);
    border-radius: 5px;
    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.05);
    backdrop-filter: blur(10px);
    background-color: rgba(255, 255, 255, 0.3);
    font-size: 1.4vmin;
    overflow-y: auto;
}
.leftPanel__header {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  height: 56px;
  z-index: 99;
  background: #fff;
}
.leftPanel__header .svg-container {
  /*position: absolute;*/
  /*top: 10px;*/
  /*left: 16%;*/
  z-index: 1;
  color: var(--v-primary-base);
  margin-right: 10px;
}
:deep table{
  margin-top: 0px !important;
}
:deep tr, td{
  height: 40px !important;
}
:deep td:first-child{
  font-size: 11px !important;
  font-weight: 700;
  color: var(--gray-color);
}
h6 {
  color: var(--gray-color);
}
</style>